// src/InvoiceBackLink.tsx
import { Button } from "@mui/material";
import { BiChevronLeft } from "react-icons/bi";
import { jsx } from "react/jsx-runtime";
var InvoiceBackLink = ({ component, to, children = "All invoices" }) => /* @__PURE__ */ jsx(Button, { component, to, startIcon: /* @__PURE__ */ jsx(BiChevronLeft, {}), size: "small", sx: { mb: 1.5, ml: -1 }, children });
var InvoiceBackLink_default = InvoiceBackLink;

// src/moveTable/InvoiceMoveTable.tsx
import { Table, TableContainer } from "@mui/material";
import { useOverflowFit } from "@hopdrive/sdk-ui";

// src/moveTable/InvoiceMoveTableHead.tsx
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { allTokens } from "@hopdrive/ui/tokens";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var TABLE_HEADER_SX = {
  padding: "10px 16px",
  textTransform: "uppercase",
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: "0.04em",
  color: allTokens.text.light.secondary,
  border: 0,
  whiteSpace: "nowrap"
};
var InvoiceMoveTableHead = ({
  headers,
  order = "asc",
  orderBy = "",
  onSort,
  checkboxColumn = "none",
  allSelected = false,
  someSelected = false,
  onSelectAll,
  disabled = false
}) => /* @__PURE__ */ jsx2(TableHead, { children: /* @__PURE__ */ jsxs(TableRow, { sx: { bgcolor: allTokens.palette.grey[50] }, children: [
  checkboxColumn !== "none" && /* @__PURE__ */ jsx2(TableCell, { sx: { width: 48, padding: "8px" }, children: checkboxColumn === "select-all" && /* @__PURE__ */ jsx2(
    Checkbox,
    {
      indeterminate: disabled ? true : someSelected && !allSelected,
      checked: disabled ? false : allSelected,
      disabled,
      onChange: onSelectAll,
      size: "small"
    }
  ) }),
  headers.map((header) => {
    if (header.hide) return null;
    const sortable = header.sortable !== false && !header.component && Boolean(onSort);
    return /* @__PURE__ */ jsx2(
      TableCell,
      {
        align: header.align,
        padding: "normal",
        sortDirection: orderBy === header.id ? order : false,
        sx: TABLE_HEADER_SX,
        children: header.component ?? (sortable ? /* @__PURE__ */ jsx2(
          TableSortLabel,
          {
            active: orderBy === header.id,
            direction: orderBy === header.id ? order : "asc",
            onClick: () => onSort?.(header.id),
            children: header.label
          }
        ) : header.label)
      },
      header.id
    );
  })
] }) });
var InvoiceMoveTableHead_default = InvoiceMoveTableHead;

// src/moveTable/columns.ts
var MOVE_TABLE_COLUMN = {
  MOVE_ID: "MOVE_ID",
  REF_NUM: "REF_NUM",
  MOVE_DATE: "MOVE_DATE",
  GUEST_NAME: "GUEST_NAME",
  LANE: "LANE",
  DLV_REP: "DLV_REP",
  DISTANCE: "DISTANCE",
  WEIGHT_CLASS: "WEIGHT_CLASS",
  COST: "COST"
};
var MOVE_TABLE_DROP_ORDER = [
  MOVE_TABLE_COLUMN.WEIGHT_CLASS,
  MOVE_TABLE_COLUMN.LANE,
  MOVE_TABLE_COLUMN.DISTANCE
];
var hiddenMoveColumns = (count) => new Set(MOVE_TABLE_DROP_ORDER.slice(0, count));

// src/moveTable/InvoiceMoveTable.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var InvoiceMoveTable = ({
  headers,
  children,
  order,
  orderBy,
  onSort,
  checkboxColumn,
  allSelected,
  someSelected,
  onSelectAll,
  disabled,
  ariaLabel
}) => {
  const [containerRef, droppedCount] = useOverflowFit(MOVE_TABLE_DROP_ORDER.length);
  const hidden = hiddenMoveColumns(droppedCount);
  return /* @__PURE__ */ jsx3(TableContainer, { ref: containerRef, children: /* @__PURE__ */ jsxs2(Table, { size: "small", "aria-label": ariaLabel, children: [
    /* @__PURE__ */ jsx3(
      InvoiceMoveTableHead_default,
      {
        headers: headers(hidden),
        order,
        orderBy,
        onSort,
        checkboxColumn,
        allSelected,
        someSelected,
        onSelectAll,
        disabled
      }
    ),
    children(hidden)
  ] }) });
};
var InvoiceMoveTable_default = InvoiceMoveTable;

// src/rooftop/RooftopExpansion.tsx
import { Box } from "@mui/material";
import { jsx as jsx4 } from "react/jsx-runtime";
var RooftopExpansion = ({ children }) => /* @__PURE__ */ jsx4(
  Box,
  {
    sx: {
      borderTop: "1px solid",
      borderColor: "divider",
      bgcolor: "background.default",
      width: 0,
      minWidth: "100%"
    },
    children
  }
);
var RooftopExpansion_default = RooftopExpansion;
export {
  InvoiceBackLink_default as InvoiceBackLink,
  InvoiceMoveTable_default as InvoiceMoveTable,
  InvoiceMoveTableHead_default as InvoiceMoveTableHead,
  MOVE_TABLE_COLUMN,
  MOVE_TABLE_DROP_ORDER,
  RooftopExpansion_default as RooftopExpansion,
  hiddenMoveColumns
};
//# sourceMappingURL=index.mjs.map